import * as React from "react"

import { cn } from "@/lib/utils"

const DATE_TYPES = new Set(["date", "datetime-local", "time", "month", "week"])

const Input = React.forwardRef(({ className, type, onClick, onFocus, ...props }, ref) => {
  const isDateLike = DATE_TYPES.has(type)

  const tryShowPicker = (e) => {
    if (!isDateLike) return
    const el = e?.currentTarget
    if (el && typeof el.showPicker === "function") {
      try { el.showPicker() } catch { /* some browsers throw if not user-activated */ }
    }
  }

  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        isDateLike && "cursor-pointer appearance-none [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:cursor-pointer relative",
        className
      )}
      ref={ref}
      onClick={(e) => { tryShowPicker(e); onClick?.(e) }}
      onFocus={(e) => { tryShowPicker(e); onFocus?.(e) }}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
